// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
[data-theme=light] {
  --widget-frame-background-color: #cdc6cc;
  --widget-frame-text-color: #1e0c1b;
  --widget-frame-button-background: #fff;
  --widget-frame-button-background--hover: #cccccc;
  --widget-frame-button-icon-fill: #291927;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

:root,
[data-theme=dark] {
  --widget-frame-background-color: #493c47;
  --widget-frame-text-color: #f5f3f5;
  --widget-frame-button-background: #1e0c1b;
  --widget-frame-button-background--hover: #4b3d49;
  --widget-frame-button-icon-fill: #f5f3f5;
  --widget-link-color: var(--fandom-link-color);
  --widget-link-color--hover: var(--fandom-link-color--hover);
  --widget-primary-background-color: var(--fandom-primary-background-color);
  --widget-text-color--secondary: var(--fandom-text-color--secondary);
  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);
  --widget-border-color--light: var(--fandom-border-color--light);
  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);
}

.widget-frame {
  display: flex;
  background-color: var(--widget-frame-background-color);
  flex-direction: column;
  padding: 12px 18px 18px 18px;
  border-radius: 3px;
  overflow: hidden;
}
@media only screen and (min-width: 768px) {
  .widget-frame {
    overflow: unset;
  }
  .widget-frame .alice-carousel .alice-carousel__wrapper {
    overflow: hidden;
  }
}
.widget-frame__content {
  padding: 9px 0 0;
  transition: height 0.2s ease-in-out;
}
.widget-frame__content--expandable {
  overflow: hidden;
}
.widget-frame > a.widget-frame__cta, .widget-frame > .widget-frame__toggle {
  gap: 6px;
  color: var(--widget-link-color);
  padding: 9px;
  margin-top: 12px;
}
.widget-frame > a.widget-frame__cta:hover, .widget-frame > a.widget-frame__cta:focus, .widget-frame > .widget-frame__toggle:hover, .widget-frame > .widget-frame__toggle:focus {
  color: var(--widget-link-color--hover);
}
.widget-frame > a.widget-frame__cta:hover svg, .widget-frame > a.widget-frame__cta:focus svg, .widget-frame > .widget-frame__toggle:hover svg, .widget-frame > .widget-frame__toggle:focus svg {
  stroke: var(--widget-link-color--hover);
}
.widget-frame > a.widget-frame__cta svg, .widget-frame > .widget-frame__toggle svg {
  margin-top: -2px;
  stroke: var(--widget-link-color);
  transition-property: stroke;
  transition-duration: 300ms;
}
.widget-frame > a.widget-frame__cta svg:hover, .widget-frame > a.widget-frame__cta svg:focus, .widget-frame > .widget-frame__toggle svg:hover, .widget-frame > .widget-frame__toggle svg:focus {
  stroke: var(--widget-link-color--hover);
}
.widget-frame__toggle--expanded svg {
  transform: rotate(180deg);
}
.widget-frame__cta-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.widget-frame .alice-carousel__arrow {
  display: none;
}
@media only screen and (min-width: 768px) {
  .widget-frame .alice-carousel__arrow {
    display: flex;
    background-color: var(--widget-frame-button-background);
    transition: background-color 0.2s ease-in-out;
  }
  .widget-frame .alice-carousel__arrow:hover {
    background-color: var(--widget-frame-button-background--hover);
  }
  .widget-frame .alice-carousel__arrow svg {
    fill: var(--widget-frame-button-icon-fill);
  }
}
.widget-frame .alice-carousel__prev-btn-item {
  left: -12px;
}
.widget-frame .alice-carousel__next-btn-item {
  right: -12px;
}
.widget-frame .alice-carousel__wrapper {
  overflow: unset;
}
.widget-frame--mobile {
  overflow: hidden;
}
.widget-frame--mobile .widget-frame__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.widget-frame--mobile .alice-carousel__arrow {
  display: none;
}
.widget-frame--mobile .alice-carousel .alice-carousel__wrapper {
  overflow: unset;
}
.widget-frame__header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.widget-frame__header .widget-frame__logo {
  height: 20px;
  width: 20px;
  text-align: right;
}
.widget-frame__header .widget-frame__title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  border: 0;
  color: var(--widget-frame-text-color);
  font-size: 16px;
  line-height: 1.25;
  font-weight: 700;
  margin: 0;
  padding: 0;
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./node_modules/@fandom-frontend/react-common/dist/components/WidgetFrame.css"],"names":[],"mappings":"AAAA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,6CAA6C;EAC7C,2DAA2D;EAC3D,yEAAyE;EACzE,mEAAmE;EACnE,iFAAiF;EACjF,+DAA+D;EAC/D,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,uDAAuD;IACvD,6CAA6C;EAC/C;EACA;IACE,8DAA8D;EAChE;EACA;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB","sourcesContent":[":root,\n[data-theme=light] {\n  --widget-frame-background-color: #cdc6cc;\n  --widget-frame-text-color: #1e0c1b;\n  --widget-frame-button-background: #fff;\n  --widget-frame-button-background--hover: #cccccc;\n  --widget-frame-button-icon-fill: #291927;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n:root,\n[data-theme=dark] {\n  --widget-frame-background-color: #493c47;\n  --widget-frame-text-color: #f5f3f5;\n  --widget-frame-button-background: #1e0c1b;\n  --widget-frame-button-background--hover: #4b3d49;\n  --widget-frame-button-icon-fill: #f5f3f5;\n  --widget-link-color: var(--fandom-link-color);\n  --widget-link-color--hover: var(--fandom-link-color--hover);\n  --widget-primary-background-color: var(--fandom-primary-background-color);\n  --widget-text-color--secondary: var(--fandom-text-color--secondary);\n  --widget-text-color--secondary--hover: var(--fandom-text-color--secondary--hover);\n  --widget-border-color--light: var(--fandom-border-color--light);\n  --widget-image-empty-state-color--secondary: var(--fandom-image-empty-state-color--secondary);\n}\n\n.widget-frame {\n  display: flex;\n  background-color: var(--widget-frame-background-color);\n  flex-direction: column;\n  padding: 12px 18px 18px 18px;\n  border-radius: 3px;\n  overflow: hidden;\n}\n@media only screen and (min-width: 768px) {\n  .widget-frame {\n    overflow: unset;\n  }\n  .widget-frame .alice-carousel .alice-carousel__wrapper {\n    overflow: hidden;\n  }\n}\n.widget-frame__content {\n  padding: 9px 0 0;\n  transition: height 0.2s ease-in-out;\n}\n.widget-frame__content--expandable {\n  overflow: hidden;\n}\n.widget-frame > a.widget-frame__cta, .widget-frame > .widget-frame__toggle {\n  gap: 6px;\n  color: var(--widget-link-color);\n  padding: 9px;\n  margin-top: 12px;\n}\n.widget-frame > a.widget-frame__cta:hover, .widget-frame > a.widget-frame__cta:focus, .widget-frame > .widget-frame__toggle:hover, .widget-frame > .widget-frame__toggle:focus {\n  color: var(--widget-link-color--hover);\n}\n.widget-frame > a.widget-frame__cta:hover svg, .widget-frame > a.widget-frame__cta:focus svg, .widget-frame > .widget-frame__toggle:hover svg, .widget-frame > .widget-frame__toggle:focus svg {\n  stroke: var(--widget-link-color--hover);\n}\n.widget-frame > a.widget-frame__cta svg, .widget-frame > .widget-frame__toggle svg {\n  margin-top: -2px;\n  stroke: var(--widget-link-color);\n  transition-property: stroke;\n  transition-duration: 300ms;\n}\n.widget-frame > a.widget-frame__cta svg:hover, .widget-frame > a.widget-frame__cta svg:focus, .widget-frame > .widget-frame__toggle svg:hover, .widget-frame > .widget-frame__toggle svg:focus {\n  stroke: var(--widget-link-color--hover);\n}\n.widget-frame__toggle--expanded svg {\n  transform: rotate(180deg);\n}\n.widget-frame__cta-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.widget-frame .alice-carousel__arrow {\n  display: none;\n}\n@media only screen and (min-width: 768px) {\n  .widget-frame .alice-carousel__arrow {\n    display: flex;\n    background-color: var(--widget-frame-button-background);\n    transition: background-color 0.2s ease-in-out;\n  }\n  .widget-frame .alice-carousel__arrow:hover {\n    background-color: var(--widget-frame-button-background--hover);\n  }\n  .widget-frame .alice-carousel__arrow svg {\n    fill: var(--widget-frame-button-icon-fill);\n  }\n}\n.widget-frame .alice-carousel__prev-btn-item {\n  left: -12px;\n}\n.widget-frame .alice-carousel__next-btn-item {\n  right: -12px;\n}\n.widget-frame .alice-carousel__wrapper {\n  overflow: unset;\n}\n.widget-frame--mobile {\n  overflow: hidden;\n}\n.widget-frame--mobile .widget-frame__title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.widget-frame--mobile .alice-carousel__arrow {\n  display: none;\n}\n.widget-frame--mobile .alice-carousel .alice-carousel__wrapper {\n  overflow: unset;\n}\n.widget-frame__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n.widget-frame__header .widget-frame__logo {\n  height: 20px;\n  width: 20px;\n  text-align: right;\n}\n.widget-frame__header .widget-frame__title {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  border: 0;\n  color: var(--widget-frame-text-color);\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n  word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
